export default function SupportFlow() {
  const steps = [
    {
      number: '01',
      title: '無料診断の依頼',
      description: 'お問い合わせフォームまたはお電話にて、無料診断をご依頼ください。',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '02',
      title: 'ヒアリング',
      description: 'オンラインまたは対面で、御社の事業内容や課題をお伺いします。',
      icon: 'ri-discuss-line'
    },
    {
      number: '03',
      title: '補助金診断レポート提出',
      description: '御社に最適な補助金制度を診断し、詳細なレポートを提出します。',
      icon: 'ri-file-chart-line'
    },
    {
      number: '04',
      title: '最適プランのご提案',
      description: '診断結果をもとに、最適なサポートプランをご提案します。',
      icon: 'ri-presentation-line'
    },
    {
      number: '05',
      title: '顧問契約',
      description: 'プランにご納得いただけましたら、顧問契約を締結します。',
      icon: 'ri-file-text-line'
    },
    {
      number: '06',
      title: 'サポート開始',
      description: '補助金・法務・LPのトータルサポートを開始します。',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="flow" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            <span className="text-blue-900">サポートの流れ</span>
          </h3>
          <p className="text-lg text-gray-600">無料診断から契約まで、スムーズにご案内します</p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-blue-900 via-orange-500 to-blue-900 transform -translate-x-1/2"></div>

          {/* モバイル用の縦線 */}
          <div className="lg:hidden absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-blue-900 via-orange-500 to-blue-900"></div>

          <div className="space-y-8 lg:space-y-12">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`flex items-start lg:items-center gap-4 lg:gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* モバイル用のアイコン */}
                <div className="lg:hidden w-16 h-16 bg-white border-4 border-blue-900 rounded-full flex-shrink-0 relative z-10 shadow-lg flex items-center justify-center">
                  <div className={`w-10 h-10 ${index % 2 === 0 ? 'bg-gradient-to-br from-blue-900 to-blue-700' : 'bg-gradient-to-br from-orange-500 to-orange-600'} rounded-full flex items-center justify-center`}>
                    <i className={`${step.icon} text-white text-lg`}></i>
                  </div>
                </div>

                {/* コンテンツ */}
                <div className={`flex-1 lg:${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                  <div className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all ${
                    index % 2 === 0 ? 'lg:ml-auto' : 'lg:mr-auto'
                  }`}>
                    <div className={`flex items-center gap-4 mb-3 ${index % 2 === 0 ? 'lg:flex-row-reverse' : ''}`}>
                      {/* デスクトップ用のアイコン */}
                      <div className="hidden lg:block w-14 h-14 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center flex-shrink-0" style={index % 2 !== 0 ? { background: 'linear-gradient(to bottom right, rgb(249, 115, 22), rgb(234, 88, 12))' } : {}}>
                        <i className={`${step.icon} text-white text-2xl`}></i>
                      </div>
                      <div className="text-left">
                        <div className={`text-sm ${index % 2 === 0 ? 'text-blue-900' : 'text-orange-500'} font-bold mb-1`}>STEP {step.number}</div>
                        <h4 className="text-xl font-bold text-gray-900">{step.title}</h4>
                      </div>
                    </div>
                    <p className="text-gray-600 text-left">{step.description}</p>
                  </div>
                </div>

                {/* デスクトップ用の中央アイコン */}
                <div className="hidden lg:block w-16 h-16 bg-white border-4 border-blue-900 rounded-full flex-shrink-0 relative z-10 shadow-lg">
                  <div className="absolute inset-2 bg-gradient-to-br from-blue-900 to-orange-500 rounded-full"></div>
                </div>

                <div className="hidden lg:block flex-1"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}